import {NgModule} from '@angular/core';
import {CloGlobalMenu} from './global-menu';
import {CommonModule} from '@angular/common';
export {CloGlobalMenu} from './global-menu';
@NgModule({
  declarations: [CloGlobalMenu],
  imports: [
    CommonModule
  ],
  exports: [CloGlobalMenu]
})
export class CloGlobalMenuModule {
}
